export default __webpack_public_path__ + "static/media/ticket.8312613a.jpg";